exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-season-js": () => import("./../../../src/pages/season.js" /* webpackChunkName: "component---src-pages-season-js" */),
  "component---src-pages-stage-js": () => import("./../../../src/pages/stage.js" /* webpackChunkName: "component---src-pages-stage-js" */),
  "component---src-pages-week-js": () => import("./../../../src/pages/week.js" /* webpackChunkName: "component---src-pages-week-js" */)
}

